var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonPicker',{staticClass:"ridestyler-showcase-size-picker",attrs:{"options":_vm.diameters,"selectedValue":_vm.selectedDiameter},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }